module.exports = __webpack_public_path__ + "img/4.ff4d35cf.jpg";